import { Controller } from "@hotwired/stimulus"

import {stimulus} from "../init"

export default class Preline  extends Controller {
    connect() {
        console.log("✅ Preline controller connected")

        // Small delay + safety check
        setTimeout(() => {
            if (window.HSStaticMethods) {
                window.HSStaticMethods.autoInit()
            } else {
                console.warn("⚠️ HSStaticMethods not found — is 'import \"preline\"' in your application.js?")
            }
        }, 50)
    }
}

stimulus.register('preline', Preline);
